module.exports = __webpack_public_path__ + "img/david-walker.4aa66cc9.png";